const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
const usd0 = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
export const money = (n) => (n === null || n === undefined || n === "" || isNaN(Number(n)) ? "—" : usd.format(Number(n)));
export const money0 = (n) => (isNaN(Number(n)) ? "—" : usd0.format(Number(n)));
export const num = (n) => new Intl.NumberFormat("en-US").format(Number(n) || 0);
export const date = (d) => (d ? new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" }) : "—");
export const dateTime = (d) =>
  d ? new Date(d).toLocaleString("en-US", { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—";
export const parseJson = (v, fb) => {
  if (v === null || v === undefined || v === "") return fb;
  if (typeof v !== "string") return v;
  try {
    return JSON.parse(v);
  } catch (e) {
    return fb;
  }
};
export const errorMessage = (err, fb = "Something went wrong. Please try again.") =>
  err?.data?.message || (err?.status === "FETCH_ERROR" ? "Can't reach the server. Check your connection." : fb);
export const toDateInput = (d) => (d ? new Date(d).toISOString().slice(0, 16) : "");

/** Download rows as a CSV file. columns: [{ key, label, value? }] */
export function downloadCsv(filename, rows, columns) {
  const esc = (v) => {
    const s = v === null || v === undefined ? "" : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [columns.map((c) => esc(c.label)).join(",")];
  rows.forEach((r) => lines.push(columns.map((c) => esc(c.value ? c.value(r) : r[c.key])).join(",")));
  const blob = new Blob(["﻿" + lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
